"use strict";

const AssetRoutineMaintenanceSubmission = function (Controller) {
  const stringKey = "submission";
  const tabHeader = "Submission";
  let $page;
  let $modal;

  var setPage = function ($thisPage) {
    $page = $thisPage;
  };

  var loadListeners = function (data) {
    if (!$page) {
      $page = $(`#assessment-modal #${stringKey}`);
    }
    $modal = $page.closest(".modal");

    // The inspection type and illicit discharge inputs live on other tabs
    $modal.on(
      "2N:FormInput",
      `[name="inspection-type"], [name="illicit-discharge"]`,
      onInvestigationInputChange,
    );
    $page.on("2N:FormInput", `[name="follow-up-needed"]`, onFollowUpNeededChange);
    $page.on("2N:FormInput", `[name="close-out-investigation"]`, onCloseOutInvestigationChange);
    // The inspection date input lives on the General Info tab
    $modal.on("2N:FormInput", "[name='date'], [name='end-time']", onStartOrEndDateChange);
    $page.on("2N:FormInput", onAnyFormInput);

    if (data) {
      toggleOpenInvestigationSections();
      toggleFollowUpNeeded(data.followUpNeeded);
      toggleCloseOutInvestigation(data.closeOutInvestigation);
    }

    renderSummary();
  };

  var unloadListeners = function () {
    $modal.off(
      "2N:FormInput",
      `[name="inspection-type"], [name="illicit-discharge"]`,
      onInvestigationInputChange,
    );
    $page.off("2N:FormInput", `[name="follow-up-needed"]`, onFollowUpNeededChange);
    $page.off("2N:FormInput", `[name="close-out-investigation"]`, onCloseOutInvestigationChange);
    $modal.off("2N:FormInput", "[name='date'], [name='end-time']", onStartOrEndDateChange);
    $page.off("2N:FormInput", onAnyFormInput);
  };

  var getProps = function () {
    return {
      closeOutReasonOptions: DryWeatherConstants.getCloseOutReasonOptions(),
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  var tabShownCallback = function () {
    renderSummary();
    onStartOrEndDateChange();
  };

  var renderSummary = function () {
    const html = nunjucks.render("modals/assetRoutineMaintenance/submissionSummary.njk", {
      resultsData: Controller.getSubmissionResults(),
    });
    $page.find("#js-asset-routine-maintenance-submission-summary").html(html);
  };

  var onAnyFormInput = function () {
    renderSummary();
  };

  var onInvestigationInputChange = function () {
    toggleOpenInvestigationSections();
    renderSummary();
  };

  var toggleOpenInvestigationSections = function () {
    const { inspectionType, illicitDischarge } = Controller.getInspectionRenderData();
    const openInvestigation =
      WqMonitoringConstants.isDryWeatherScreeningType(inspectionType) && illicitDischarge === true;
    $page.find(`.show-when-open-investigation`).toggle(openInvestigation);
  };

  var onFollowUpNeededChange = function (e, followUpNeeded) {
    toggleFollowUpNeeded(followUpNeeded);
  };

  var toggleFollowUpNeeded = function (followUpNeeded) {
    $page.find(`.follow-up-needed-show-when-follow-up`).toggle(followUpNeeded);
  };

  var onCloseOutInvestigationChange = function (e, closeOutInvestigation) {
    toggleCloseOutInvestigation(closeOutInvestigation);
  };

  var toggleCloseOutInvestigation = function (closeOutInvestigation) {
    $page.find(`.close-out-investigation-show-when-close-out`).toggle(closeOutInvestigation);
  };

  var onStartOrEndDateChange = function () {
    const startTime = $modal.find("[name='date']").val();
    const endTime = $page.find("[name='end-time']").val();
    const totalElement = $page.find("[name='total-inspection-time']")[0];

    setDateRanges();
    const startMinute = getEpochMinute(startTime);
    const endMinute = getEpochMinute(endTime);
    if (startMinute === null || endMinute === null) {
      NumberInput.clear(totalElement);
    } else {
      NumberInput.manuallySetInput(totalElement, endMinute - startMinute);
    }
  };

  // Dates are displayed to the minute, so ignore seconds to avoid apparent off-by-one durations
  var getEpochMinute = function (isoString) {
    const date = DateTime.parseIsoDate(isoString);
    return date ? Math.floor(date.getTime() / (1000 * 60)) : null;
  };

  var setDateRanges = function () {
    const startTime = $modal.find("[name='date']").val();
    const endTime = $page.find("[name='end-time']").val();

    if (startTime) {
      DateTimePicker.setDatePickerRange($modal, "end-time", false, startTime);
    }
    if (endTime) {
      DateTimePicker.setDatePickerRange($modal, "date", true, endTime);
    }
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
    setPage,
    tabShownCallback,
    renderSummary,
    onStartOrEndDateChange,
  };
};

module.exports = AssetRoutineMaintenanceSubmission;

const DateTime = require("../../dateTime");
const DateTimePicker = require("../../general/dateTimePicker");
const NumberInput = require("../../general/numberInput");
const DryWeatherConstants = require("../../illicitDischarge/dryWeatherScreening/dryWeatherConstants");
const WqMonitoringConstants = require("../../wq/inspection/wqMonitoringConstants");
